<template>
  <div :style="{ position: 'relative', width: width + 'px', height: height + 'px' }">
    <div :title="errorMsg" :style='{color:errorMsg ? "yellow" : "#fff"}'
         style="position: absolute; top: 10px; right: 10px; opacity: 0.8">
      {{ DeviceName }}
    </div>
    <iframe v-if="videosrc && videosrc.length > 0" ref="videobox" :src="videosrc" :width="width + 'px'"
            :height="height + 'px'" allowfullscreen frameborder="no" style="float: left"></iframe>
    <div :style="{
        background: 'black',
        height: height + 'px',
        width: DeviceType == 2 ? width * 0.8 + 'px' : width + 'px',
      }" v-if="!(videosrc && videosrc.length > 0)"></div>
  </div>
</template>

<script>
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'
import {
  getAction
} from '@/api/manage'
import Vue from 'vue'

export default {
  name: 'IwsVideo',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 600
    },
    height: {
      type: Number,
      required: false,
      default: 400
    },
    DeviceSerial: {
      //设备序列号
      type: String,
      required: false,
      default: ''
    },
    DeviceCode: {
      //设备验证码
      type: String,
      required: false,
      default: ''
    },
    DeviceType: {
      //平台类型模式: 1.摄像头2.云台
      type: Number,
      required: false,
      default: 1
    },
    DeviceName: {
      type: String,
      required: true
    },
    channel: {
      //通道号摄像头默认为1,nvr有多个通道
      type: Number,
      required: false,
      default: 1
    },
    dpi: {
      //HD高清地址后缀.hd.live SD流畅地址后缀.live
      type: String,
      required: false,
      default: 'HD'
    },
    templete: {
      //播放器模式: 0极简版 1标准版
      type: Number,
      required: false,
      default: 1
    },
    type: {
      //平台类型模式: 1.萤石云 2.拾联平台
      type: Number,
      required: false,
      default: 1
    },
    autoplay: {
      //是否自动播放: 1.自动 0.手动
      type: String,
      required: false,
      default: '0'
    },
    siteId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      videosrc: '',
      errorMsg: ''
    }
  },
  created() {
    // getAction('/sys/video/view/hik/'+ this.DeviceSerial).then(res=>{
    //
    // })
    this.reloadurl()
  },
  watch: {
    DeviceSerial: function(val) {
      this.reloadurl()
    },
    DeviceCode: function(val) {
      this.reloadurl()
    },
    channel: function(val) {
      this.reloadurl()
    },
    dpi: function(val) {
      this.reloadurl()
    },
    templete: function(val) {
      this.reloadurl()
    },
    type: function(val) {
      this.reloadurl()
    },
    DeviceType: function(val) {
      this.reloadurl()
    }
  },
  methods: {
    reloadurl() {
      console.log('reloadurl', this.type, this.DeviceSerial)
      var videourl = ''
      if (this.type && this.type == 2) {
        videourl = location.origin + '/Live/view.html'
        if (this.DeviceSerial && this.DeviceSerial.length > 0) {
          //获取平台token
          getAction('/sys/video/token?type=' + this.type)
            .then((res) => {
              if (res.success) {
                if (res.result) {
                  if (res.result.token) {
                    videourl +=
                      '?tk=' +
                      res.result.token +
                      '&deviceSerial=' +
                      this.DeviceSerial +
                      '&autoplay=' +
                      this.autoplay +
                      '&channel=' +
                      this.channel +
                      '&type=' +
                      this.type +
                      '&deviceType=' +
                      this.DeviceType +
                      '&siteId=' +
                      this.siteId
                  }
                }
              }
              this.videosrc = videourl
            })
            .catch((error) => {
              // this.videosrc = location.origin + '/Live/view.html'
            })
        }
      } else if (this.type && this.type == 3) {
        videourl = location.origin + '/HK/view.html'
        if (this.DeviceSerial) {
          videourl = location.origin + '/HK/view.html?deviceType=' + this
              .DeviceType+ '&autoplay=' + this.autoplay + '&siteId=' + this.siteId + '&deviceSerial=' + this.DeviceSerial + '&channel=' +
            this.channel + '&type=' + this.type + '&token=' + Vue.ls.get(ACCESS_TOKEN)
          this.videosrc = videourl
          // getAction(`/sys/video/view/hik/${this.DeviceSerial}/${this.siteId}`).then(res => {
          //   if (res.success) {

          //   }else{
          //     this.$message.warning('取流失败,请检查流媒体平台是否正常......')
          //   }
          // }).catch((error) => {
          //   // this.videosrc = location.origin + '/HK/view.html'
          // })
        }
      } else if (this.type && this.type == 4) {
        videourl = location.origin + '/Jessibuca/index.html'
        if (this.DeviceSerial && this.DeviceSerial.length > 0) {
          getAction('/sys/video/view/GB28181/' + this.DeviceSerial + '/' + this.channel)
            .then((res) => {
              if (res.success) {
                if (res.result) {
                  videourl += '?url=' + res.result + '&autoplay=' + this.autoplay + '&deviceType=' + this.DeviceType + '&channel=' +
                    this.channel + '&type=' + this.type + '&deviceSerial=' + this.DeviceSerial
                }
                this.errorMsg = ''
              } else {
                this.videosrc = location.origin + '/Jessibuca/index.html'
                this.errorMsg = res.message
              }
              console.log(videourl)
              this.videosrc = videourl
            })
            .catch((error) => {
              this.videosrc = location.origin + '/Jessibuca/index.html?errorMsg=' + this.DeviceSerial
              this.errorMsg = error
            })
        }
      } else if (this.type && this.type == 1) {
        videourl = location.origin + '/EZUIKit/iframe_se.html?url='
        //构建url地址
        if (this.DeviceCode && this.DeviceCode.length > 0) {
          videourl += 'ezopen://' + this.DeviceCode + '@open.ys7.com/'
        } else {
          videourl += 'ezopen://open.ys7.com/'
        }
        if (this.DeviceSerial && this.DeviceSerial.length > 0) {
          let dpi = this.dpi == 'HD' ? '.hd.live' : '.live'
          let templete = this.templete && this.templete >= 0 && this.templete <= 4 ? this.templete : 0
          const token = Vue.ls.get(ACCESS_TOKEN)
          //获取平台token
          getAction('/sys/video/token?type=' + this.type)
            .then((res) => {
              if (res.success) {
                if (res.result) {
                  if (res.result.token) {
                    videourl +=
                      this.DeviceSerial +
                      '/' +
                      this.channel +
                      dpi +
                      '&autoplay=0&audio=1&accessToken=' +
                      res.result.token + '&deviceType=' + this.DeviceType + '&type=' + this.type +
                      '&templete=' +
                      templete +
                      '&deviceSerial=' +
                      this.DeviceSerial +
                      '&channel=' +
                      this.channel +
                      '&token=' +
                      token +
                      '&siteId=' + this.siteId
                  }
                }
              }
              console.log(videourl)
              this.videosrc = videourl
            })
            .catch((error) => {
              // this.videosrc = location.origin + '/EZUIKit/iframe_se.html?autoplay=0'
            })
        }
      }
    },
    ptzcontroller(status, direction, msg) {
      var pram = {
        type: this.type,
        deviceSerial: this.DeviceSerial,
        direction: direction,
        status: status,
        channel: this.channel,
        siteId: this.siteId
      }
      getAction('/sys/video/ptz', pram)
        .then((res) => {
          if (res.success && msg) {
            // this.$notification.warning({ message: res.message })
          }
        })
        .catch((error) => {
          if (msg) this.$notification.success({
            message: '操作失败!'
          })
        })
    },
    ptztimeout(direction, timeout) {
      this.ptzcontroller('start', direction, false)
      setTimeout(() => {
        this.ptzcontroller('stop', direction, false)
      }, timeout)
    },
    startptz(direction) {
      this.ptzcontroller('start', direction, true)
    },
    stopptz(direction) {
      this.ptzcontroller('stop', direction, true)
    }
  }
}
</script>

<style scoped>
.more-btn {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  color: #fff;
  border-radius: 50%;
  background-color: #eee;
  position: absolute;
  top: 80px;
  right: 10px;
}

.directionKey {
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 50%;
  background-color: #eee;
  position: absolute;
  top: 40px;
  right: 50px;
}

.center {
  width: 40px;
  height: 40px;
  border: 1px solid #eee;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  top: 30px;
  left: 30px;
}

.btns {
  position: absolute;
  color: #aaa;
}

.btns:hover {
  color: #fff;
}

.up {
  top: 0px;
  left: calc(50% - 12px);
}

.down {
  bottom: 0px;
  left: calc(50% - 12px);
}

.left {
  top: calc(50% - 12px);
  left: 0px;
}

.right {
  top: calc(50% - 12px);
  right: 0px;
}
</style>
